import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
var styles = xcss({
  width: '100%',
  borderBlockEnd: 'none',
  borderBlockStart: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
  borderInline: 'none'
});
export var Divider = function Divider() {
  return /*#__PURE__*/React.createElement(Box, {
    as: "hr",
    xcss: styles,
    role: "presentation"
  });
};